<template>
  <main>
    <div class="cs-body w-100 invisible-scroll" ref="scrollContainer">
      <!-- <section v-if="from == 'addDocModule'">
        <div class="cs-bold-txt-2">
          {{ type == "predefined" ? "Predefined" : "Custom" }} Document
        </div>
        <div class="cf-light-txt mt-1">
          {{
            type == "predefined"
              ? "Select predefined documents from the dropdown below"
              : "Create new documents with available types for your custom needs"
          }}
        </div>
      </section> -->
      <template v-if="from == 'addDocModule'">
        <InputDropdown
          class="position-relative"
          label="File Name"
          placeholder="Enter"
          :mandatory="true"
          :dropdown="true"
          :type="type"
          :values="requiredDocuments"
          :vmodel="type == 'predefined' ? documentData.key : documentData.label"
          :showError="showFieldError"
          @select-input-value="setInputData"
          :disableDropdown="action === 'edit'"
          :disabled="action === 'edit'"
        />
        <template v-if="type == 'custom'">
          <div
            class="errortxt"
            v-if="
              validationObj.documentData.label.$dirty &&
              !validationObj.documentData.label.required
            "
          >
            Required
          </div>
          <div
            class="errortxt"
            v-else-if="!validationObj.documentData.label.maxLength"
          >
            Exceeded character limit
          </div>
          <div
            class="errortxt"
            v-else-if="!validationObj.documentData.label.validateName"
          >
            File name already exists
          </div>
        </template>
        <div class="errortxt" v-else-if="showFieldError">Required</div>
      </template>
      <template v-else>
        <Input
          :vmodel="documentData.label"
          placeholder="Enter"
          label="File Name"
          :mandatory="true"
          :disabled="from === 'addDocModule' && action === 'edit'"
          :showError="validationObj.documentData.label.$error"
          @select-value="
            (documentData.label = $event),
              validationObj.documentData.label.$touch()
          "
        />
        <div
          class="errortxt"
          v-if="
            validationObj.documentData.label.$dirty &&
            !validationObj.documentData.label.required
          "
        >
          Required
        </div>
        <div
          class="errortxt"
          v-else-if="!validationObj.documentData.label.maxLength"
        >
          Exceeded character limit
        </div>
        <div
          class="errortxt"
          v-else-if="!validationObj.documentData.label.validateName"
        >
          File name already exists
        </div>
      </template>
      <section v-if="from == 'addDocModule'">
        <label class="teams-label-font mt-3">
          File Type
          <span class="asterik">*</span>
        </label>
        <div
          class="
            selectCustom-field
            d-flex
            align-items-center
            justify-content-between
            cursor-not-allowed
            content-box
          "
        >
          <div>
            <img src="@/assets/img/hrdocuments/file.svg" alt />
            <span class="ml-2 inputPlaceholder-font">Upload File</span>
          </div>
          <img
            class="arrow-disable-opacity"
            src="@/assets/cvsearch/cv-downarrow.svg"
            alt
          />
        </div>
      </section>
      <div class="select-div">
        <div class="common-single-checkbox and-label">
          <b-form-checkbox v-model="documentData.mandatory" class="mt-3"
            >Required</b-form-checkbox
          >
          <b-form-checkbox
            v-if="type != 'predefined'"
            v-model="documentData.downloadTemplate"
            class="mt-3"
          >
            Download Template
            <div class="cf-light-txt">
              Candidate will be able to download the document
            </div>
          </b-form-checkbox>
          <UploadDocument
            v-if="documentData.downloadTemplate && type != 'predefined'"
            class="mt-3"
            label="Upload Document"
            id="addDocument"
            :mandatory="true"
            :disabled="disabledUpload"
            :maxFileSize="documentData.maxFileSize"
            :fileFormat="documentData.fileFormat"
            :vmodel="uploadData"
            :showError="validationObj.uploadData.$error || differentFileFormat"
            :type="documentData.controlType"
            @select-value="$emit('select-upload', $event)"
          />
          <div class="errortxt" v-if="differentFileFormat">
            Invalid file format
          </div>
          <div class="errortxt" v-else-if="validationObj.uploadData.$error">
            Required
          </div>
          <b-form-checkbox v-model="documentData.allowMultiple" class="mt-3">
            Allow Multiple Files
            <div class="cf-light-txt">
              Candidate will be able to upload multiple files
            </div>
          </b-form-checkbox>
        </div>

        <label class="teams-label-font mt-3">
          File Format
          <span class="asterik">*</span>
        </label>
        <div
          v-if="type == 'predefined'"
          class="
            cs-dropdown-field
            mt-1
            cursor-not-allowed
            content-box content-height
          "
        >
          <div class="w-94 text-truncate">
            <span
              v-if="documentData.fileFormat.length == 0"
              class="acs-filter-dropdown-place"
              >Select</span
            >
            <span v-else class="cs-dropdown-sel-txt">
              {{ getSelectedFormatLabels(documentData.fileFormat) }}
            </span>
          </div>
          <img
            class="arrow-disable-opacity"
            src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
            alt=""
          />
        </div>
        <div v-else class="position-relative">
          <div
            ref="fileFormatOpen"
            :class="{ redError: validationObj.documentData.fileFormat.$error }"
            @click="definefileformatDrop = !definefileformatDrop"
            class="cs-dropdown-field mt-1 content-height"
          >
            <div class="w-94 text-truncate">
              <span
                v-if="documentData.fileFormat.length == 0"
                class="acs-filter-dropdown-place"
                >Select</span
              >
              <span v-else class="cs-dropdown-sel-txt">
                <span
                  v-b-tooltip.hover.bottom="
                    getSelectedFormatLabels(documentData.fileFormat)
                  "
                  >{{ getSelectedFormatLabels(documentData.fileFormat) }}</span
                >
              </span>
            </div>
            <img src="@/assets/img/accessconnew/blueDownArrowSmall.svg" alt />
          </div>
          <b-collapse
            ref="fileFormatDrop"
            v-closable="{
              exclude: ['fileFormatDrop', 'fileFormatOpen'],
              handler: 'hideFileFormatDropdown',
            }"
            v-model="definefileformatDrop"
            class="cs-dropdown maxHei-500"
          >
            <div v-for="key in Object.keys(fileType)" :key="key">
              <div class="bg-white cf-light-txt pl-2 content-bg">{{ key }}</div>
              <div
                @click="selectFileFormat(i)"
                v-for="i in fileType[key]"
                :key="i.label"
                class="cs-options"
                :class="checkIncludes(i) && 'cs-options-selected'"
              >
                {{ i.label }}
              </div>
            </div>
          </b-collapse>
        </div>
        <div
          class="errortxt"
          v-if="
            validationObj.documentData.fileFormat.$error && type != 'predefined'
          "
        >
          Required
        </div>
        <Input
          class="mt-3"
          label="File Size Limit (MB)"
          placeholder="Enter"
          :mandatory="true"
          type="number"
          :vmodel="documentData.maxFileSize"
          :showError="validationObj.documentData.maxFileSize.$error"
          @select-value="
            (documentData.maxFileSize = $event),
              validationObj.documentData.maxFileSize.$touch()
          "
        />
        <div
          class="errortxt"
          v-if="
            validationObj.documentData.maxFileSize.$dirty &&
            !validationObj.documentData.maxFileSize.required
          "
        >
          Required
        </div>
        <div
          class="errortxt"
          v-else-if="!validationObj.documentData.maxFileSize.between"
        >
          Should be between 1 and 20
        </div>
      </div>
    </div>
    <div
      :class="from == 'reqDoc' && 'mb-2'"
      class="
        d-flex
        align-items-center
        justify-content-end
        border-top
        mt-2
        pt-2
        pr-3
      "
    >
      <b-button
        @click="$emit('close-form')"
        class="acs-cancelBtn-modal width-87 mr-3 mt-1"
        >Cancel</b-button
      >
      <div class="position-relative">
        <b-button
          @click="!showLoader ? $emit('add-document', differentFileFormat) : ''"
          :class="showLoader && 'disabled-kanban-img'"
          class="acs-addBtn-modal width-87 mt-1"
        >
          <span :class="showLoader && 'invisible'">
            {{ action === "add" ? "Add" : "Update" }}
          </span>
        </b-button>
        <div v-if="showLoader" class="doc-add-loader-pos">
          <Loader />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import InputDropdown from "@/components/InputComponents/InputDropdown.vue";
import Input from "@/components/InputComponents/Input.vue";
import UploadDocument from "@/components/InputComponents/UploadDocument.vue";
import Loader from "../fixedcomponents/Loader.vue";
import { getFileType } from "../../controllers/commonHelpers";

export default {
  name: "AddNewDocument",
  props: {
    documentData: Object,
    validationObj: Object,
    uploadData: [Array, File],
    getSelectedFormatLabels: Function,
    action: String,
    from: String,
    initialType: String,
    showLoader: Boolean,
    requiredDocuments: Array,
  },
  data() {
    return {
      inputData: "",
      type: "",
      differentFileFormat: false,
      definefileformatDrop: false,
      fileType: {
        "Image File": [
          { label: "GIF", value: ["GIF"] },
          { label: "JPEG", value: ["JPEG"] },
          { label: "JPG", value: ["JPG"] },
          { label: "PNG", value: ["PNG"] },
          { label: "SVG", value: ["SVG"] },
          { label: "TTF or TIF", value: ["TTF", "TIF"] },
        ],
        "Document File": [
          { label: "PDF", value: ["PDF"] },
          { label: "CSV", value: ["CSV"] },
          { label: "DOC and DOCX", value: ["DOC", "DOCX"] },
          { label: "XLS and XLSX", value: ["XLS", "XLSX"] },
        ],
        Number: [
          { label: "HTML", value: ["HTML"] },
          { label: "TXT", value: ["TXT"] },
        ],
        "Video File": [
          { label: "MP4", value: ["MP4"] },
          { label: "MKV", value: ["MKV"] },
          { label: "Webm", value: ["Webm"] },
          { label: "AVI", value: ["AVI"] },
          { label: "MOV", value: ["MOV"] },
          { label: "FLV", value: ["FLV"] },
          { label: "AVCHD", value: ["AVCHD"] },
        ],
        "Presentation File": [
          { label: "PPT and PPTX", value: ["PPT", "PPTX"] },
          { label: "ODP", value: ["ODP"] },
          { label: "Key", value: ["Key"] },
        ],
        "Audio File": [
          { label: "MPEGA audio (M4A)", value: ["MPEGA audio (M4A)"] },
          { label: "MP3", value: ["MP3"] },
          { label: "WAV", value: ["WAV"] },
        ],
      },
    };
  },
  created() {
    if (this.from == "addDocModule") this.type = this.initialType;
  },
  components: { Input, UploadDocument, Loader, InputDropdown },
  watch: {
    type(value) {
      this.$emit("type-changed", value);
    },
    initialType() {
      if (this.from == "addDocModule") this.type = this.initialType;
    },
    "documentData.fileFormat"(value) {
      if (
        this.uploadData &&
        this.documentData.downloadTemplate &&
        value.length != 0 &&
        this.uploadData?.length != 0
      ) {
        this.validateFile();
      } else this.differentFileFormat = false;
    },
    uploadData(value) {
      if (value && this.documentData.downloadTemplate && value?.length != 0) {
        this.validateFile();
      } else this.differentFileFormat = false;
    },
  },
  computed: {
    showFieldError() {
      if (this.type == "predefined")
        return this.validationObj.documentData.key.$error;
      else {
        return (
          (this.validationObj.documentData.label.$dirty &&
            !this.validationObj.documentData.label.required) ||
          !this.validationObj.documentData.label.maxLength ||
          !this.validationObj.documentData.label.validateName
        );
      }
    },
    disabledUpload() {
      return (
        !this.documentData.maxFileSize ||
        this.validationObj.documentData.maxFileSize.$error ||
        !this.documentData.fileFormat ||
        this.documentData.fileFormat?.length == 0
      );
    },
  },
  methods: {
    setInputData(value, type) {
      if (type == "predefined") this.documentData.key = value;
      else this.documentData.label = value;
      if (this.action !== "edit") {
        this.type = type;
        this.$emit("change-type", type);
      }
    },
    validateFile() {
      let fileType;
      if (this.uploadData instanceof File) {
        fileType = this.uploadData.name.split(".").pop();
      } else fileType = this.getFileType(this.uploadData[0])[0];
      if (!this.documentData.fileFormat.includes(fileType.toUpperCase()))
        this.differentFileFormat = true;
      else this.differentFileFormat = false;
    },
    getFileType(link) {
      return getFileType(link);
    },
    selectFileFormat(i) {
      for (let j of i.value) {
        let ind = this.documentData.fileFormat.indexOf(j);
        if (ind != -1) {
          this.documentData.fileFormat.splice(ind, 1);
        } else {
          this.documentData.fileFormat.push(j);
        }
      }
    },
    checkIncludes(i) {
      return i.value.every((element) =>
        this.documentData.fileFormat.includes(element)
      );
    },
    hideFileFormatDropdown() {
      this.definefileformatDrop = false;
    },
  },
};
</script>

<style>
.doc-add-loader-pos {
  position: absolute;
  top: -50px;
  z-index: 1;
  left: -4px;
}
.content-box {
  background: #f7f7f7 !important;
}
.content-height {
  height: 39px !important;
}
.content-bg {
  background-color: #f9f9f9;
}

.and-label label {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #344054;
}
.and-label .grey-txt {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #7a7a7a;
}
</style>
